import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AsideLayout = _resolveComponent("AsideLayout")!

  return (_openBlock(), _createBlock(_component_AsideLayout, { "image-path": "set-credentials-aside.svg" }, {
    title: _withCtx(() => _cache[0] || (_cache[0] = [
      _createTextVNode("Password requirements")
    ])),
    list: _withCtx(() => _cache[1] || (_cache[1] = [
      _createElementVNode("li", null, "At least 8 characters", -1),
      _createElementVNode("li", null, "A lowercase letter", -1),
      _createElementVNode("li", null, "An uppercase letter", -1),
      _createElementVNode("li", null, "A number", -1),
      _createElementVNode("li", null, "No parts of username", -1)
    ])),
    _: 1
  }))
}